module.exports = __webpack_public_path__ + "fe148528a5052cc5544be640c2f2c06f.pdf";